import { FluentProvider } from '@fluentui/react-components';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AppStore } from '../../redux/store';
import { MsalProvider } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { semanticKernelLightTheme } from '../../styles';
import { AppServicesProvider } from './AppServicesContext';


interface AppProvidersProps {
    children: React.ReactNode;
    msalInstance: IPublicClientApplication;
    store: AppStore;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children, msalInstance, store }) => {
    return (
        <Provider store={store}>
            <MsalProvider instance={msalInstance}>
                <AppServicesProvider>
                    <FluentProvider theme={semanticKernelLightTheme}>
                        <BrowserRouter>
                            {children}
                            <ToastContainer autoClose={2000} />
                        </BrowserRouter>
                    </FluentProvider>
                </AppServicesProvider>
            </MsalProvider>
        </Provider>
    );
};

export default AppProviders;
